const initialState = {
    str: ''
}

const medCertPlaceIssueRed = (state = initialState, action) => {
    switch(action.type){
        case 'MEDCERT_PLACEISSUE' : {
            return {
                ...state,
                str: action.str
            }
        }
        default: {
            return state
        }
    }
}

export default medCertPlaceIssueRed